import React from 'react';
import { useSelector } from 'react-redux';
import DocumentsModern from 'src/components/Documents/DocumentsModern';
import LoadState from 'src/components/LoadState/LoadState';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';

interface Item {
  id: string;
  name: string;
}

interface ItemDocumentsProps {
  item: Item;
  documents: any[];
  loadingDocs: boolean;
  isSaving: boolean;
  saveDocument: (
    document: DocumentFormData,
    entityId: string,
    userId: string
  ) => Promise<void>;
  deleteDocument: (documentId: string) => Promise<boolean>;
}

const ItemDocuments = ({
  item,
  documents,
  loadingDocs,
  isSaving,
  saveDocument,
  deleteDocument,
}: ItemDocumentsProps) => {
  const user: any = useSelector(selectAuthenticatedUser);

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, item.id, user.id);
  };

  const onDeleteDocument = async (document: any): Promise<void> => {
    await deleteDocument(document.id);
  };

  return (
    <DocumentsModern
      documents={documents}
      user={user}
      labelName="Manuals & Documents"
      saving={isSaving}
      loading={loadingDocs}
      onSave={onSave}
      onDeleteDocument={onDeleteDocument}
    />
  );
};

export default ItemDocuments;
